import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ConsClotureMotifType from './cons-cloture-motif-type';
import ConsClotureMotifTypeDetail from './cons-cloture-motif-type-detail';
import ConsClotureMotifTypeUpdate from './cons-cloture-motif-type-update';
import ConsClotureMotifTypeDeleteDialog from './cons-cloture-motif-type.delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ConsClotureMotifTypeUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ConsClotureMotifTypeUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ConsClotureMotifTypeDetail} />
      <ErrorBoundaryRoute path={match.url} component={ConsClotureMotifType} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ConsClotureMotifTypeDeleteDialog} />
  </>
);

export default Routes;
